__turbopack_context__.v({
  "footerPattern": "footerPattern-module-scss-module__2XdNWG__footerPattern",
});
